import RestoreFromTrashRoundedIcon from "@material-ui/icons/RestoreFromTrashRounded";
import { useNavigate } from "react-router-dom";
import { getAllSuppliers } from "../../reduxSaga/actions";

import { useSelector, useDispatch } from "react-redux";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import { useEffect, useRef, useState } from "react";
import EditRealWarehouse from "../../ui/EditRealWarehouse";
import { Snackbar } from "@material-ui/core";
import PurchaseService from "../../services/PurchaseOrder";
// import uploadAndDownloadService from "../../services/uploadAndDownloadFile";
import { Alert } from "@material-ui/lab";

import UploadFactureFile from "../../ui/UploadFactureFile";
// import UtilsUrl from "../../utils/UtilsUrl";
// import BDCNonConfirme from "./Table/BDCNonConfirme";
import FactureNonConfirme from "./Table/FactureNonConfirme";
import FactureArchived from "./Table/FactureArchived";
import withLoader from "../../components/layouts/WithLoader";
import getCurrentUserId from "../../reduxSaga/sagas/requests/currentUserId";
import CashRegisterService from "../../services/ProductSellBToC/CashRegisterService";

const Factures = ({ startLoading, stopLoading }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const suppliers = useSelector((state) => state.staff.suppliers.Societe);

  const [oldWarehouseData, setOldWarehouseData] = useState();
  const [onEditWarehouse, setOnEditWarehouse] = useState(false);
  const animatedComponents = makeAnimated();
  const [userRole, setUserRole] = useState("");
  const [supplierId, setSupplierId] = useState(0);
  const [supplierSelectPlaceHolder, setSupplierSelectPlaceHolder] =
    useState("Tous");
  const [allSuppliers, setAllSuppliers] = useState([
    { value: 0, label: "Tous" },
  ]);
  // const [inConfirmedBdc, setInConfirmedBdc] = useState([]);

  const [dateBegin, setDateBegin] = useState("any");
  const [dateEnd, setDateEnd] = useState("any");
  const [supplierSelectedOption, setSupplierSelectedOption] = useState(null);
  const [selectedOption, setSelectedOption] = useState(null);
  const [inConfirmedFacture, setInConfirmedFacture] = useState([]);
  const [terminedFacture, setTerminedFacture] = useState([]);
  const [archivedFacture, setArchivedFacture] = useState([]);
  const [factureRelatedToInvoice, setFactureRelatedToInvoice] = useState([]);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();
  const [onUploadFile, setOnUploadFile] = useState(false);
  const [factureUploadInformation, setFactureUploadInformation] = useState({
    reference: "any",
    state: 0,
    inConfirmedFacture: inConfirmedFacture,
  });

const [allMagasin, setAllMagasin] = useState([]);
  const [magasinSelectPlaceHolder, setMagasinSelectPlaceHolder] =
    useState("");
    const [magasinSelectedOption, setMagasinSelectedOption] = useState(null);
  const [magasinId, setMagasinId] = useState(0);

  const [chargedFactureInfo, setChargedFactureInfo] = useState(false);
  const [chargedFactureArchivedInfo, setChargedFactureArchivedInfo] =
    useState(false);
  // incrémenté à chaque filtrage pour remonter les tableaux (données à jour)
  const [tablesVersion, setTablesVersion] = useState(0);
  const filterRequestId = useRef(0);

  useEffect(() => {
    if (onUploadFile === "false") {
      console.log("inConfirmedFacture", inConfirmedFacture);
    }
  }, [onUploadFile]);

  useEffect(() => {
    if (localStorage.getItem("status") === null) {
      setUserRole(["notConnected"]);
    } else {
      setUserRole(JSON.parse(localStorage.getItem("status")));
    }

    dispatch(getAllSuppliers());
  setAllMagasin([])
     CashRegisterService.getAllShop(getCurrentUserId())
          .then((response) => {
            if (response.data.success) {
              response.data.success.map((element) => {
                setAllMagasin((oldArray) => [
                  ...oldArray,
                  { value: element.id, label: element.name },
                ]);
              })
              // setAvailableShop(response.data.success);
    
            } else {
              console.log("error in getAllShop", response.data.success);
            }
          })
          .catch((e) => {
            console.log("error in getAllShop", e);
          });
    startLoading();
    let pendingRequests = 2;
    const requestDone = () => {
      pendingRequests -= 1;
      if (pendingRequests === 0) stopLoading();
    };
    PurchaseService.getFactureOfLastMonth(0)
      .then((response) => {
        if (response.data.success) {
          console.log(response.data.success);

          response.data.success.forEach((element) => {
            setInConfirmedFacture((previoustate) => [...previoustate, element]);
          });
          setChargedFactureInfo(true);
        } else if (Object.keys(response.data)[0] === "empty") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : facture last month not deleted");
      })
      .finally(requestDone);
    PurchaseService.getFactureOfLastMonth(1)
      .then((response) => {
        if (Object.keys(response.data)[0] === "success") {
          setArchivedFacture(response.data.success);
          setChargedFactureArchivedInfo(true);
        } else if (Object.keys(response.data)[0] === "empty") {
        }
      })
      .catch(() => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : facture last month deleted");
      })
      .finally(requestDone);
  }, []);

    const onChangeSelectedMagasin = (selectedOptionn) => {
    setSelectedOption();
    setMagasinId(selectedOptionn.value);
    setMagasinSelectedOption(selectedOptionn.label);
    setMagasinSelectPlaceHolder(selectedOptionn.label)
  };

  useEffect(() => {
    suppliers &&
      suppliers.map((element, i) => {
        let exist = false;
        if (allSuppliers.length !== 0) {
          for (let index = 0; index < allSuppliers.length; index++) {
            if (allSuppliers[index].value === element?.id) {
              exist = true;
              break;
            }
          }
        }

        if (element?.id !== undefined && exist === false) {
          setAllSuppliers((oldArray) => [
            ...oldArray,
            { value: element.id, label: element.title },
          ]);
        }
      });
  }, [suppliers]);
  useEffect(() => {
    if (dateBegin === ":59") {
      setDateBegin("any");
    }
    if (dateEnd === ":59") {
      setDateEnd("any");
    }
  }, [dateBegin, dateEnd]);

  const onAddFactureHandler = () => {
    navigate(`/addFacture`);
  };

  const onChangeSelectedSupplier = (selectedOptionn) => {
    setSelectedOption();
    setSupplierId(selectedOptionn.value);
    setSupplierSelectPlaceHolder(selectedOptionn.label);
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const onChangeDateBegin = (event) => {
    const selectedValue = event.target.value;

    // Check if the selected value already includes a time part
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":00" // If time exists, append ":00" to set seconds to 00
      : selectedValue + "T00:00:00"; // If it's a date-only input, append "T00:00:00" for the first second of the day

    setDateBegin(updatedValue);
  };


  const onChangeDateEnd = (event) => {
    const selectedValue = event.target.value;

    // Check if the selected value already includes a time part
    const updatedValue = selectedValue.includes("T")
      ? selectedValue.split(":").slice(0, 2).join(":") + ":59" // If time exists, append ":59" to set seconds to 59
      : selectedValue + "T23:59:59"; // If it's a date-only input, append "T23:59:59" for the last second of the day

    setDateEnd(updatedValue);
  };


  const onGetFacturesByFiltersHandler = () => {
    const requestId = ++filterRequestId.current;
    // -1 : archivées, 0 / 1 / 2 : autres états
    const states = [-1, 0, 1, 2];

    startLoading();
    Promise.all(
      states.map((state) =>
        PurchaseService.getFactureByFilters(
          supplierId,
          state,
          dateBegin,
          dateEnd,
          magasinId
        )
      )
    )
      .then((responses) => {
        // ignorer la réponse d'un ancien clic sur "Valider le choix"
        if (requestId !== filterRequestId.current) return;

        const extract = (res) =>
          Array.isArray(res.data?.success) ? res.data.success : [];
        const [archived, ...others] = responses.map(extract);

        setArchivedFacture(archived);
        setInConfirmedFacture(others.flat());
        setChargedFactureInfo(true);
        setChargedFactureArchivedInfo(true);
        setTablesVersion((v) => v + 1);
      })
      .catch((error) => {
        setOpenErrorAlert(true);
        setErrorAlertText("Erreur : " + error);
      })
      .finally(() => {
        stopLoading();
      });
  };
  const onAddFactureImportHandler = () => {
    navigate(`/addFactureImport`);
  };

  const labelStyle = {
    fontSize: "0.8rem",
    fontWeight: 600,
    textTransform: "uppercase",
    letterSpacing: "0.03em",
    color: "#6c757d",
  };
  const cardStyle = { borderRadius: 8, boxShadow: "0 1px 6px rgba(0,0,0,.08)" };
  const canCreate =
    userRole.includes("ADMIN") || userRole.includes("PURCHASING_MANAGER");
  const canCreateImport =
    canCreate && !userRole.includes("RESPONSABLE_MARKETING");

  const fmt = (v) => parseFloat(Number(v).toFixed(3));
  const caHT = inConfirmedFacture.reduce(
    (sum, r) => sum + (Number(r.buyingPrice) || 0),
    0
  );
  const caTT = inConfirmedFacture.reduce(
    (sum, r) => sum + (Number(r.ttPrice) || 0),
    0
  );
  const totalTVA = caTT - caHT;
  const nbAttente = inConfirmedFacture.filter((r) => r.state === 0).length;
  const nbEnCours = inConfirmedFacture.filter((r) => r.state === 1).length;
  const nbTermine = inConfirmedFacture.filter((r) => r.state === 2).length;

  const kpis = [
    { label: "CA H.T", value: fmt(caHT), hint: "Somme P.A.HT", icon: "fas fa-dollar-sign" },
    { label: "CA T.T", value: fmt(caTT), hint: "Somme P.A.TT", icon: "fas fa-dollar-sign" },
    { label: "Total TVA", value: fmt(totalTVA), hint: "P.A.TT - P.A.HT", icon: "fas fa-hand-holding-usd" },
  ];

  const newButton = (label, onClick) => (
    <button
      className="btn btn-dark mr-2 mb-1 d-inline-flex align-items-center"
      style={{ borderRadius: 8, padding: "8px 18px 8px 10px", fontWeight: 500 }}
      onClick={onClick}
    >
      <span
        className="d-inline-flex align-items-center justify-content-center mr-2"
        style={{
          width: 26,
          height: 26,
          borderRadius: 6,
          backgroundColor: "rgba(255,255,255,.18)",
        }}
      >
        <i className="fas fa-plus" style={{ fontSize: 12 }} />
      </span>
      {label}
    </button>
  );

  return (
    <div className="content-wrapper" style={{ marginTop: "0" }}>
      <section className="content-header">
        <div className="container-fluid">
          <div className="d-flex flex-wrap justify-content-between align-items-center">
            <div>
              <h4 className="mb-1">
                <i className="fas fa-file-invoice-dollar mr-2"></i>Les factures
                d'achat
              </h4>
              <small className="text-muted">
                Par défaut, les factures ajoutées durant le dernier mois
              </small>
            </div>
            <div className="mt-2 mt-sm-0">
              {canCreate && newButton("Nouvelle facture", onAddFactureHandler)}
              {canCreateImport &&
                newButton("Nouvelle facture d'import", onAddFactureImportHandler)}
            </div>
          </div>
        </div>
      </section>

      <section className="content">
        <div className="container-fluid">
          <div className="card card-outline card-dark mt-3" style={cardStyle}>
            <div className="card-header">
              <h3 className="card-title">
                <i className="fas fa-filter mr-2"></i>Filtres
              </h3>
            </div>
            <div className="card-body">
              <div className="row">
                {/* <div className="col-md-3">
                  <div className="form-group">
                    <label style={labelStyle}>Magasin</label>
                    <Select
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      defaultValue={magasinSelectedOption}
                      onChange={onChangeSelectedMagasin}
                      options={allMagasin}
                      placeholder={magasinSelectPlaceHolder}
                    />
                  </div>
                </div> */}
                <div className="col-md-4">
                  <div className="form-group">
                    <label style={labelStyle}>Fournisseur</label>
                    <Select
                      closeMenuOnSelect={false}
                      components={animatedComponents}
                      defaultValue={supplierSelectedOption}
                      onChange={onChangeSelectedSupplier}
                      options={allSuppliers}
                      placeholder={supplierSelectPlaceHolder}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="facture-date-begin" style={labelStyle}>
                      Date début
                    </label>
                    <input
                      id="facture-date-begin"
                      type="date"
                      className="form-control"
                      onChange={onChangeDateBegin}
                    />
                  </div>
                </div>
                <div className="col-md-4">
                  <div className="form-group">
                    <label htmlFor="facture-date-end" style={labelStyle}>
                      Date fin
                    </label>
                    <input
                      id="facture-date-end"
                      type="date"
                      className="form-control"
                      onChange={onChangeDateEnd}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="card-footer text-right">
              <button
                className="btn btn-dark"
                onClick={onGetFacturesByFiltersHandler}
              >
                <i className="fas fa-search mr-1"></i>
                Valider le choix
              </button>
            </div>
          </div>

          {chargedFactureInfo && (
            <>
              <div className="row">
                {kpis.map((k) => (
                  <div className="col-md-3 col-sm-6" key={k.label}>
                    <div
                      className="d-flex align-items-center p-3 mb-3 bg-white"
                      style={{ ...cardStyle, borderLeft: "4px solid #343a40" }}
                    >
                      <span
                        className="d-flex align-items-center justify-content-center bg-dark text-white mr-3"
                        style={{ width: 44, height: 44, borderRadius: 8 }}
                      >
                        <i className={k.icon}></i>
                      </span>
                      <div>
                        <small
                          className="text-muted text-uppercase d-block"
                          style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                        >
                          {k.label}
                        </small>
                        <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                          {k.value}
                        </span>
                        <small className="text-muted d-block">{k.hint}</small>
                      </div>
                    </div>
                  </div>
                ))}
                <div className="col-md-3 col-sm-6">
                  <div
                    className="d-flex align-items-center p-3 mb-3 bg-white"
                    style={{ ...cardStyle, borderLeft: "4px solid #343a40" }}
                  >
                    <span
                      className="d-flex align-items-center justify-content-center bg-dark text-white mr-3"
                      style={{ width: 44, height: 44, borderRadius: 8 }}
                    >
                      <i className="fas fa-truck"></i>
                    </span>
                    <div>
                      <small
                        className="text-muted text-uppercase d-block"
                        style={{ fontWeight: 600, letterSpacing: "0.03em" }}
                      >
                        État livraison
                      </small>
                      <span style={{ fontSize: "1.3rem", fontWeight: 700 }}>
                        {inConfirmedFacture.length}
                      </span>
                      <small className="text-muted ml-1">facture(s)</small>
                      <div>
                        <span className="badge badge-warning mr-1">
                          {nbAttente} En attente
                        </span>
                        <span className="badge badge-primary mr-1">
                          {nbEnCours} En cours
                        </span>
                        <span className="badge badge-success">
                          {nbTermine} Terminé
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <FactureNonConfirme
                key={`nc-${tablesVersion}`}
                listFacture={inConfirmedFacture}
              />
            </>
          )}

          {chargedFactureArchivedInfo && (
            <FactureArchived
              key={`ar-${tablesVersion}`}
              listFacture={archivedFacture}
            />
          )}
        </div>
      </section>

      {onEditWarehouse && (
        <EditRealWarehouse
          setOnEditWarehouse={setOnEditWarehouse}
          oldWarehouseData={oldWarehouseData}
        />
      )}
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
      {onUploadFile && (
        <UploadFactureFile
          setOnUploadFile={setOnUploadFile}
          setInConfirmedFacture={setInConfirmedFacture}
          setTerminedFacture={setTerminedFacture}
          setFactureRelatedToInvoice={setFactureRelatedToInvoice}
          factureUploadInformation={factureUploadInformation}
          setArchivedFacture={setArchivedFacture}
        />
      )}
    </div>
  );
};
export default withLoader(Factures);
